import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const VenuePortal = lazy(() => import("@/pages/VenuePortal"));

export const Route = createFileRoute("/venue-portal")({
  component: VenuePortal,
});
